// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const { map, isEmpty, chain, set, delay } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');
const { ESTATES_TYPE_ABBREVIATION } = require('constants/mortgageRequestEstates');

const resetLocation = () => ({
    type: actionTypes.MORTGAGE_REQUEST_RESET_LOCATION_DATA
});

const setEstatesWithProvinces = data => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_ESTATES_WITH_PROVINCES,
    data
})

const setEstatePopulationData = data => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_ESTATE_POPULATION,
    data
});

const setEstateRegisterData = data => ({
    type: actionTypes.MORTGAGE_REQUEST_SET_ESTATE_REGISTER,
    data
});

const fetchLocationDataDone = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_LOCATION_DATA_DONE
})

const requestFetchProvinces = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROVINCES_REQUEST
});

const requestFetchProvincesSuccess = provinces => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROVINCES_SUCCESS,
    data: { provinces }
});

const requestFetchProvincesFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_PROVINCES_FAILURE,
    data: { error }
});

const requestFetchPopulation = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_POPULATION_REQUEST
});

const requestFetchPopulationSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_POPULATION_SUCCESS,
    data
});

const requestFetchPopulationFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_POPULATION_FAILURE,
    data: { error }
});

const requestFetchRegisters = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_REGISTERS_REQUEST
});

const requestFetchRegistersSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_REGISTERS_SUCCESS,
    data
});

const requestFetchRegistersFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_REGISTERS_FAILURE,
    data: { error }
});

const requestProvincesData = (setProvinceDataForSelects = false) => (dispatch, getState) => {

    if (getState().mortgageRequestLocationData.get('isFetching')) {
        return false;
    }

    dispatch(requestFetchProvinces());

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestProvincesData'
    })
        .then(response => {
            dispatch(requestFetchProvincesSuccess(response.data));
            setProvinceDataForSelects && requestSelectsData()(dispatch, getState); // eslint-disable-line
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(requestFetchProvincesFailure(response.error))
            } else {
                throw response;
            }
        });
};

const requestLocationData = (provinceId, populationId, formItemId, requestPopulation = false, requestRecord = false, ignoreFetching = false) => (dispatch, getState) => {

    if (!ignoreFetching && getState().mortgageRequestLocationData.get('isFetching')) {
        return false;
    }

    if (populationId === undefined) {

        dispatch(requestFetchPopulation());

        const populationParams = {
            query: {
                provinceId
            }
        };


        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestPopulationsData',
            params: populationParams
        })
            .then(response => {
                const itemData = {
                    formItemId,
                    provinceId,
                    populationsList: response.data
                }

                dispatch(requestFetchPopulationSuccess(itemData));

                if (requestPopulation !== false) {
                    getPopulationData(requestPopulation, dispatch, getState); // eslint-disable-line
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestFetchPopulationFailure(response.error))
                } else {
                    throw response;
                }
            });
    } else {
        dispatch(requestFetchRegisters());

        const registerParams = {
            query: {
                provinceId,
                populationId
            }
        };

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestRegistersData',
            params: registerParams
        })
            .then(response => {
                const itemData = {
                    formItemId,
                    provinceId,
                    populationId,
                    registersList: response.data
                };

                dispatch(requestFetchRegistersSuccess(itemData));

                if (requestRecord !== false) {
                    getRecordData(requestRecord, dispatch, getState); // eslint-disable-line
                }
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestFetchRegistersFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

const getRecordData = (idx, dispatch, getState) => {

    const estate = getState().mortgageRequestInmuebles.getIn(['list', idx]).toJS();
    const registerList = getState().mortgageRequestLocationData.getIn(['registersData', 'registersList']).toJS();
    const registerName = chain(registerList).find({ 'id': estate.registerId }).get('name').value();

    dispatch(setEstateRegisterData({
        idx,
        registerData: {
            value: estate.registerId,
            label: registerName
        },
        registerList
    }));

    requestRecordData(++idx, dispatch, getState); // eslint-disable-line
};

const requestRecordData = (idx, dispatch, getState) => {
    const estatesData = getState().mortgageRequestInmuebles.get('list').toJS();

    /**
     * acaba el proceso despues de traer los registros de los inmuebles donde
     * sea tipo reg o reg_data
     */
    if (estatesData.length === idx) {

        dispatch(fetchLocationDataDone());
    } else {
        const estate = estatesData[idx];

        /**
         * traer los reg si es tipo reg
         */
        if (estate.idType === 'REG_DATA' || estate.idType === 'REG') {

            requestLocationData(estate.provinceId, estate.populationId, 0, false, idx)(dispatch, getState);
        } else {

            requestRecordData(++idx, dispatch, getState);
        }

    }
};

const getPopulationData = (idx, dispatch, getState) => {

    const estate = getState().mortgageRequestInmuebles.getIn(['list', idx]).toJS();
    const populationList = getState().mortgageRequestLocationData.getIn(['populationData', 'populationsList']).toJS();
    const populationName = chain(populationList).find({ 'id': estate.populationId }).get('name').value();

    dispatch(setEstatePopulationData({
        idx,
        populationData: {
            value: estate.populationId,
            label: populationName
        },
        populationList
    }));

    requestPopulationsDataForSelect(++idx, dispatch, getState); // eslint-disable-line
};

const requestPopulationsDataForSelect = (idx, dispatch, getState) => {
    const estatesData = getState().mortgageRequestInmuebles.get('list').toJS();

    /**
     * busca los datos registrales despues de traer todas las poblaciones donde los inmuebles tengan provincia
     */
    if (idx === estatesData.length) {

        requestRecordData(0, dispatch, getState);
    } else {
        const estate = estatesData[idx];

        /**
         * consulta todas las poblaciones donde los inmuebles tengan provincia
         */
        if (estate.provinceId) {

            requestLocationData(estate.provinceId, undefined, 0, idx)(dispatch, getState);
        } else {

            requestPopulationsDataForSelect(++idx, dispatch, getState);
        }
    }
}

const setProvincesData = (provincesData, estatesData, dispatch, getState) => {

    if (isEmpty(provincesData)) {
        delay(() => requestProvincesData(true)(dispatch, getState), 1000); // evitar conflictos con la ejecucion del render

    } else {

        const newEstatesData = map(estatesData, estate => {

            if (estate.idType !== 'CRU' || estate.type === ESTATES_TYPE_ABBREVIATION.VIVIENDA) {

                return set(estate, 'provinceData', {
                    label: chain(provincesData).find({ 'id': estate.provinceId }).get('name').value(),
                    value: estate.provinceId
                });
            }

            return estate;
        });

        dispatch(setEstatesWithProvinces(newEstatesData));

        requestPopulationsDataForSelect(0, dispatch, getState);
    }
};

const requestSelectsData = () => (dispatch, getState) => {
    const estatesData = getState().mortgageRequestInmuebles.get('list').toJS();
    const provincesData = getState().mortgageRequestLocationData.get('provincesList').toJS();

    setProvincesData(provincesData, estatesData, dispatch, getState);
};

const resetLocationData = () => dispatch => dispatch(resetLocation());

module.exports = {
    requestProvincesData,
    requestLocationData,
    requestSelectsData,
    resetLocationData
};
